export default "/_next/static/assets/images/sprite.770edd2a870003754497bf1042f7f796.svg";